(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jl-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jl-bundles')) {
    customElements.define('jl-bundles', class extends HTMLElement {
      connectedCallback() {
        this.prices = JSON.parse(this.querySelector('[data-jl-prices]').textContent);
        this.discounts = { 1: 0, 2: Number(this.dataset.d2 || 0), 3: Number(this.dataset.d3 || 0) };
        this.qty = 1;
        try {
          this.fmt = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        } catch (e) {
          this.fmt = new Intl.NumberFormat('en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        }
        this.section = this.closest('.shopify-section') || document;
        this.section.classList.add('jl-has-bundles');
        this.querySelectorAll('.jl-bundle').forEach((card) => {
          card.addEventListener('click', (e) => { if (!e.target.closest('select')) this.select(Number(card.dataset.qty)); });
          card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.select(Number(card.dataset.qty)); } });
          card.querySelectorAll('select[data-item]').forEach((s) => s.addEventListener('change', () => { this.select(Number(card.dataset.qty)); this.render(); }));
        });
        this.onSubmit = this.onSubmit.bind(this);
        window.addEventListener('submit', this.onSubmit, true);   // window capture runs before Horizon's document-level handler
        this.timer = setInterval(() => this.sync(), 400);
        this.sync(true);
      }
      disconnectedCallback() { clearInterval(this.timer); window.removeEventListener('submit', this.onSubmit, true); }
      form() { return this.section.querySelector('form[data-type="add-to-cart-form"]'); }
      formVariant() { return this.form()?.querySelector('input[name="id"]')?.value; }
      card(q) { return this.querySelector(`.jl-bundle[data-qty="${q}"]`); }
      items(q = this.qty) {
        const selects = [...this.card(q).querySelectorAll('select[data-item]')];
        if (!selects.length) return Array(q).fill(this.formVariant());
        return selects.map((s) => s.value);
      }
      select(qty) {
        this.qty = qty;
        this.querySelectorAll('.jl-bundle').forEach((el) => {
          const on = Number(el.dataset.qty) === qty;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.sync(true);
      }
      sync(force) {
        const input = this.form()?.querySelector('input[name="quantity"]');
        if (input && Number(input.value) !== this.qty) {
          input.value = this.qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const vid = this.formVariant();
        if (force || vid !== this.lastVid) {
          if (vid !== this.lastVid) {          // keep the 2/3-pack dropdowns in line with the main size picker
            this.querySelectorAll('select[data-item]').forEach((s) => { if (this.prices[vid] !== undefined) s.value = vid; });
          }
          this.lastVid = vid;
          this.render();
        }
      }
      render() {
        const first = Object.values(this.prices)[0];
        this.querySelectorAll('.jl-bundle').forEach((el) => {
          const q = Number(el.dataset.qty);
          const full = this.items(q).reduce((sum, id) => sum + (this.prices[id] ?? first), 0);
          const now = Math.round(full * (1 - this.discounts[q] / 100));
          el.querySelector('[data-price]').textContent = this.fmt.format(now / 100);
          el.querySelector('[data-compare]').textContent = now < full ? this.fmt.format(full / 100) : '';
          const save = el.querySelector('[data-save]');
          if (save) save.textContent = this.fmt.format((full - now) / 100);
        });
      }
      async onSubmit(event) {
        const form = this.form();
        if (event.target !== form || this.qty === 1) return;
        const ids = this.items();
        if (ids.every((id) => id === this.formVariant())) return;   // same size for all -> normal form submit
        event.preventDefault();
        event.stopImmediatePropagation();
        const counts = {};
        ids.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
        const items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (res.ok) window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jl-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jl-delivery')) {
    customElements.define('jl-delivery', class extends HTMLElement {
      connectedCallback() {
        const add = (date, days) => {
          const d = new Date(date);
          let left = Number(days);
          while (left > 0) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) left--;
          }
          return d;
        };
        const f = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        const range = (a, b) => (f(a) === f(b) ? f(a) : `${f(a)} – ${f(b)}`);
        const now = new Date();
        const ds = this.dataset;
        this.querySelector('[data-d="order"]').textContent = f(now);
        this.querySelector('[data-d="ship"]').textContent = range(add(now, ds.shipMin), add(now, ds.shipMax));
        this.querySelector('[data-d="deliver"]').textContent = range(add(now, ds.deliverMin), add(now, ds.deliverMax));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
